/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from 'react-bootstrap';
import BaseCom from './BaseCom';
import { ErrorAlert } from './ErrorAlert';

export class ErrorAlertModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            children: [],
            show: false
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        ErrorAlert.init(this.showModal, this.hideModal, this.showConfirm);
    }

    showModal(appendToChildren, title) {
        if (!title)
            title = 'Error';
        if (appendToChildren && appendToChildren === 'Unexpected token ' < ', "<html><bod"... is not valid JSON')
            appendToChildren = 'Unknown error, this might be an update being applied.';
        let children = [...this.state.children];
        children.push(<div className="mb-2">{appendToChildren}</div>);
        this.setState({ children: children, title: title, show: true, noFooter: false, onConfirm: null });
    }

    hideModal() {
        this.setState({ children: [], title: null, show: false });
    }

    showConfirm(children, title, callback, cancelCallback) {
        this.setState({ children: children, title: title, show: true, onConfirm: callback, onCancel: cancelCallback });
    }

    render() {
        return <div className="ErrorAlertModal">
            {this.state.show && <Modal show={this.state.show} onHide={() => { this.hideModal(); this.state.onToggle?.(); }} style={{ zIndex: '99999991' }}>
                {this.state.title ? <Modal.Header>
                    <Modal.Title>{this.state.title}</Modal.Title>
                </Modal.Header> : ''}
                <Modal.Body>
                    {this.state.children}
                </Modal.Body>
                {!this.state.noFooter ? <Modal.Footer>
                    <button className="btn btn-secondary btn-lg" onClick={() => { this.hideModal(); this.state.onToggle?.(); }}>Close</button>
                </Modal.Footer> : ''}
            </Modal>}
        </div>;
    }
}